<template>
  <div
    class="flex flex-col gap-3 rounded-md border border-slate-200 bg-white p-3 dark:border-slate-600 dark:bg-slate-800"
  >
    <BaseShowEditTranslation
      v-model:translations="form.label"
      :label="$t('attributes.name')"
      name="label"
      :errors="errors?.label"
      required
    />
    <div class="flex flex-row justify-end gap-2">
      <BaseButton
        icon="times"
        size="small"
        color="warning"
        :title="$t('button.cancel')"
        @click="$emit('close')"
      />
      <BaseButton
        icon="paper-plane"
        size="small"
        color="primary"
        :title="listItem?.id ? $t('button.save') : $t('button.add')"
        :disabled="!isValid"
        @click="submitForm"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

/**
 * Adds a list item to `groupName`, or edits `listItem`, on a copy (cancel
 * leaves the item unchanged): FM's translation input, one language at a
 * time.
 */
export default {
  name: 'AddListItemFormComponent',
  props: {
    listItem: { type: Object, required: false, default: null },
    groupName: { type: String, required: true }
  },
  emits: ['close'],
  data() {
    return {
      form: this.listItem
        ? { ...this.listItem, label: { ...this.listItem.label } }
        : { group: this.groupName, label: {} }
    }
  },
  computed: {
    ...mapGetters({ errors: 'auth/getErrors' }),
    isValid() {
      return Object.values(this.form.label).some((value) => value?.trim())
    }
  },
  methods: {
    ...mapActions({
      updateListItem: 'itemList/updateListItem',
      storeListItem: 'itemList/storeListItem'
    }),
    submitForm() {
      const save = this.form.id ? this.updateListItem : this.storeListItem
      save({ listItem: this.form }).then(() => this.$emit('close'))
    }
  }
}
</script>
